import "@hotwired/turbo-rails";
import * as ActiveStorage from "@rails/activestorage";
import "./controllers";
import "./theme";
import "./toast";
import "./channels";

ActiveStorage.start();
